let ticketWidgetStarted = false;

export function markTicketWidgetStarted() {
  ticketWidgetStarted = true;
}

export function initialiseTicketWidget(api, browser = window) {
  if (typeof api?.init !== 'function') return;
  const initialise = api.init;
  let started = false;
  browser.removeEventListener('load', initialise);
  api.init = (...args) => {
    if (started) return;
    started = true;
    return initialise.apply(api, args);
  };
  api.init();
}

export function reloadAfterTicketWidget(location, prevLocation, browser = window) {
  const pathname = path => path.replace(/\/+$/, '') || '/';
  if (!ticketWidgetStarted || !prevLocation || pathname(location.pathname) === pathname(prevLocation.pathname)) {
    return;
  }

  // Ferve owns global state, timers and requests that outlive a React page.
  // A fresh document prevents their callbacks from updating another event.
  browser.location.replace(`${location.pathname}${location.search || ''}${location.hash || ''}`);
}

export function getTicketBookingUrl(html, tickets = []) {
  const source = html?.match(/<script\b[^>]*\bsrc\s*=\s*["']([^"']+)["']/i)?.[1];
  if (!source) return null;

  try {
    const script = new URL(source.replace(/&(?:amp|#0*38|#x0*26);/gi, '&'));
    if (!/\/FTAPI\.js$/i.test(script.pathname)) return null;
    const base = new URL(script.searchParams.get('s') || script.searchParams.get('u') || script.origin);
    if (!['https:', 'http:'].includes(base.protocol)) return null;

    // Use an event link from the CMS when supplied. The Ferve event list is
    // available even when its embedded widget is blocked on this website.
    for (const block of tickets || []) {
      for (const mark of block.markDefs || []) {
        const href = mark.href || mark.url;
        if (!href) continue;
        try {
          const link = new URL(href, base);
          if (link.origin === base.origin && /^\/Events\//i.test(link.pathname)) return link.href;
        } catch {
          // An invalid CMS link must not remove the default booking fallback.
        }
      }
    }

    return new URL('Events', `${base.href.replace(/\/+$/, '')}/`).href;
  } catch {
    return null;
  }
}
